import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useWorkspaceId } from "@/hooks/use-workspace";
import { useSubscription } from "@/hooks/use-subscription";
import { useAuth } from "@/lib/auth";
import { getBillingPeriod } from "@/lib/billing-period";

export function useAiCredits() {
  const { data: workspaceId } = useWorkspaceId();
  const { isPro, loading: subLoading } = useSubscription();
  const { subscription } = useAuth();

  const period = getBillingPeriod(subscription.subscription_end);
  const defaultLimit = isPro ? 100 : 50;

  const query = useQuery({
    queryKey: ["ai-credits", workspaceId, period, defaultLimit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("ai_credits")
        .select("used, monthly_limit")
        .eq("workspace_id", workspaceId!)
        .eq("month", period)
        .maybeSingle();
      if (error) throw error;
      const used = data?.used ?? 0;
      const limit = data?.monthly_limit ?? defaultLimit;
      return { used, limit, remaining: limit - used };
    },
    enabled: !!workspaceId && !subLoading,
    staleTime: 30_000,
  });

  return {
    used: query.data?.used ?? 0,
    limit: query.data?.limit ?? defaultLimit,
    remaining: query.data?.remaining ?? defaultLimit,
    loading: query.isLoading,
    refetch: query.refetch,
  };
}
